import { get } from 'lodash';

export const canCreate = (postType: any, space: any) => {
  return get(space, `permissions.can_create_${postType}`);
};
